<template>
  <div class="login">
    <div class="container">
      <div class="login-main">
        <div class="login-title">
          <div class="login-title-item" v-for="(item, index) in types" :key="index"
               :class="[index === typeIndex ? 'current' : '']" @click="changeType(index)">
            {{ item }}
          </div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" v-if="typeIndex === 0">
          <el-form-item prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号码"
                      prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item prop="captcha">
            <el-col :span="15">
              <el-input v-model="ruleForm.captcha" placeholder="请输入图形验证码"
                        prefix-icon="el-icon-c-scale-to-original"></el-input>
            </el-col>
            <el-col :span="9" class="code">
              <el-image :src="captcha_path" fit="fill" class="captcha" title="点击更换图形验证码"
                        @click="getCaptcha"></el-image>
            </el-col>
          </el-form-item>
          <el-form-item prop="code">
            <el-col :span="15">
              <el-input v-model="ruleForm.code" placeholder="请输入短信验证码"
                        prefix-icon="el-icon-message"></el-input>
            </el-col>
            <el-col :span="9" class="code">
              <el-button type="primary" @click="getCode()" class="code-btn" :disabled="vcodeBtn">{{
                  vcodeBtnName
                }}
              </el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="agreement">同意</el-checkbox>
            <router-link to="/agreement">
              《用户服务协议和隐私政策》
            </router-link>
            <div class="login-intro">新用户推荐短信登录，登录即注册成功！个人中心可设置密码。</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" class="login-btn">登录</el-button>
          </el-form-item>
        </el-form>
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" v-if="typeIndex === 1">
          <el-form-item prop="phone2">
            <el-input v-model="ruleForm2.phone2" placeholder="请输入手机号码"
                      prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <el-form-item prop="password2">
            <el-input v-model="ruleForm2.password2" placeholder="请输入密码"
                      prefix-icon="el-icon-key" type="password"></el-input>
          </el-form-item>
          <el-form-item prop="captcha2">
            <el-col :span="15">
              <el-input v-model="ruleForm2.captcha2" placeholder="请输入图形验证码"
                        prefix-icon="el-icon-c-scale-to-original"></el-input>
            </el-col>
            <el-col :span="9" class="code">
              <el-image :src="captcha_path" fit="fill" class="captcha" title="点击更换图形验证码"
                        @click="getCaptcha"></el-image>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="agreement">同意</el-checkbox>
            <router-link to="/agreement">
              《用户服务协议和隐私政策》
            </router-link>
            <div class="login-intro">新用户推荐短信登录，登录即注册成功！个人中心可设置密码。</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm2('ruleForm2')" class="login-btn">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {request} from '@/utils/request'
import ls from "@/utils/localStorage";

export default {
  name: "Login",
  head: {
    title: "登录"
  },
  data() {
    return {
      types: ['短信登录', '密码登录'],
      typeIndex: 0,
      captcha_path: '',
      captcha_key: '',
      agreement: true,
      ruleForm: {
        phone: '',
        captcha: '',
        code: '',
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号码', trigger: 'blur'}
        ],
        captcha: [
          {required: true, message: '请输入图片验证码', trigger: 'blur'},
          {len: 5, message: '请输入5位数图片验证码', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'},
          {len: 6, message: '短信验证码格式错误', trigger: 'blur'}
        ],
      },
      countNum: 60,
      vcodeBtnName: "获取验证码",
      countDownTimer: null,
      vcodeBtn: false,
      ruleForm2: {
        phone2: '',
        password2: '',
        captcha2: ''
      },
      rules2: {
        phone2: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号码', trigger: 'blur'}
        ],
        password2: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        captcha2: [
          {required: true, message: '请输入图片验证码', trigger: 'blur'},
          {len: 5, message: '请输入5位数图片验证码', trigger: 'blur'}
        ],
      },
    };
  },
  created() {
    this.getCaptcha()
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false
        }

        let verificationCode = {
          key: ls.getItem('verificationCode_key'),
          expiredAt: ls.getItem('verificationCode_expiredAt')
        }
        if (!verificationCode.key) {
          this.$message.error('请发送短信验证码')
          return
        }
        if (new Date().getTime() > verificationCode.expiredAt) {
          this.$message.error('验证码已过期')
          return
        }

        if (!this.agreement) {
          this.$message.error('请您同意用户服务协议和隐私政策')
          return
        }

        try {
          await this.$store.dispatch('login', {
            phone: this.ruleForm.phone,
            verification_code: this.ruleForm.code,
            verification_key: verificationCode.key
          })
          this.$message.success('登录成功')
          this.$router.back()
        } catch (e) {
          console.log(e.response)
        }
      });
    },
    submitForm2(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false
        }

        if (!this.agreement) {
          this.$message.error('请您同意用户服务协议和隐私政策')
          return
        }

        try {
          await this.$store.dispatch('passLogin', {
            phone: this.ruleForm2.phone2,
            password: this.ruleForm2.password2,
            captcha_key: this.captcha_key,
            captcha_code: this.ruleForm2.captcha2,
          })
          this.$message.success('登录成功')
          this.$router.back()
        } catch (e) {
          this.getCaptcha()
          console.log(e.response)
        }
      });
    },
    async getCaptcha() {
      let response = await request('/captchas', {
        method: 'GET'
      })
      this.captcha_path = response.data.captcha_image_content
      this.captcha_key = response.data.captcha_key
    },
    async getCode() {
      let flag = true

      this.$refs['ruleForm'].validateField('phone', (valid) => {
        if (valid) {
          flag = false
        }
      })
      this.$refs['ruleForm'].validateField('captcha', (valid) => {
        if (valid) {
          flag = false
        }
      })

      if (!flag) {
        return
      }

      if (this.vcodeBtnName !== '获取验证码' && this.vcodeBtnName !== '重新发送') {
        return
      }

      try {
        let response = await request('/verificationPcCodes', {
          method: 'POST',
          data: {
            captcha_key: this.captcha_key,
            captcha_code: this.ruleForm.captcha,
            phone: this.ruleForm.phone
          }
        })
        this.vcodeBtnName = '正在发送...'
        this.$message({
          message: '短信已发送，请注意查收',
          type: 'success'
        });
        ls.setItem('verificationCode_key', response.data.key)
        ls.setItem('verificationCode_expiredAt', Date.parse(response.data.expired_at))
        // 倒计时
        this.countNum = 60
        this.vcodeBtn = true
        this.countDownTimer = setInterval(function () {
          this.countDown();
        }.bind(this), 1000)
      } catch (e) {
        this.getCaptcha()
      }
    },
    countDown() {
      if (this.countNum < 1) {
        clearInterval(this.countDownTimer)
        this.vcodeBtnName = "重新发送"
        this.vcodeBtn = false
        return
      }
      this.countNum--
      this.vcodeBtnName = this.countNum + '秒重发'
    },
    changeType(index) {
      if (index === 0) {
        this.$refs['ruleForm2'].resetFields()
      } else if(index === 1) {
        this.$refs['ruleForm'].resetFields()
      }
      this.typeIndex = index
    }
  }
}
</script>

<style scoped>
.login {
  background-image: url("../../static/images/banner.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 700px;
  position: relative;
}

.login-main {
  width: 350px;
  background-color: #ffffff;
  padding: 20px;
  position: absolute;
  top: 12.5%;
  right: 16%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.login-title {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  color: #999999;
  cursor: pointer;
}

.login-title-item {
  border: 1px solid #ebebeb;
  width: 48%;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;
}

.login-title-item:hover, .login-title-item.current {
  background-color: #2aacb2;
  color: #ffffff;
  border-color: #2aacb2;
}

.code {
  display: flex;
  justify-content: flex-end;
}

.captcha {
  width: 112px;
  height: 40px;
  border-radius: 4px;
}

.login-btn {
  width: 100%;
}

.code-btn {
  width: 112px;
}

.login-intro{
  color: #999999;
  font-size: 12px;
  line-height: 30px;
}
</style>